import { Builder } from '@builder.io/react'

import { contentSwitcherItemsInput } from '@src/components/ContentSwitcher/ContentSwitcher.builder'
import { ContentSwitcherDefaults } from '@src/components/ContentSwitcher/ContentSwitcher.defaults'

import { LocaleContentSwitcher } from './LocaleContentSwitcher'

Builder.registerComponent(LocaleContentSwitcher, {
  name: 'LocaleContentSwitcher',
  inputs: [
    {
      name: 'previewMode',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'items',
      friendlyName: 'Items',
      type: 'list',
      subFields: [
        ...contentSwitcherItemsInput.subFields,
        {
          name: 'matchUrlLocale',
          type: 'string',
          defaultValue: '/us/en',
          helperText:
            'If the URL locale matches this value, this item will be selected by default. Example: /us/en.',
        },
      ],
      defaultValue: ContentSwitcherDefaults.items,
    },
  ],
})
